module.exports = __webpack_public_path__ + "img/5ENG_Cover.a405aeed.jpg";